// Public functions
import getConfig from 'utils/getConfig'

const { publicRuntimeConfig } = getConfig() || {}

const googleClientId = publicRuntimeConfig.GOOGLE_CLIENT_ID

const GooglePromise = () => {
  return new Promise((resp) => {
    const client = window.google.accounts.oauth2.initCodeClient({
      client_id: googleClientId,
      scope:
        'email profile openid https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email',
      callback: resp,
    })
    client.requestCode()
  })
}

const load = ({ appId }) => {
  if (document.getElementById('google-client')) {
    return
  }

  const js = document.createElement('script')

  js.src = '//accounts.google.com/gsi/client'
  js.id = 'google-client'

  js.onload = () => {
    window.google.accounts.id.initialize({
      client_id: appId,
      // callback: (response) => {
      //   console.log(response)
      // },
    })
    // TODO:: THIS IS ONE-TAP PROMPT FOR GOOGLE SIGN IN - NEED TO CREATE A HANDLER FOR IT. THIS APPEARS ONLY IF THE USER IS SIGNIN IN THE BROWSER
    // window.google.accounts.id.prompt()
  }

  document.body.appendChild(js)
}

const login = async () => {
  const response = await GooglePromise()

  return response.code
}

export default {
  load,
  login,
}
